// ----------------------------------------------------------
// © Copyright 2021 European Space Agency, 2021
// This file is subject to the terms and conditions defined in file 'LICENSE.txt', which is part of this [source code/executable] package. No part of the package, including this file, may be copied, modified, propagated, or distributed except according to the terms contained in the file ‘LICENSE.txt’.
// -----------------------------------------------------------
import { getServiceContainer } from "../service-container";
import { appState } from "../store";
import { Logger } from "../global/logger";
const logger = new Logger("global", "checks");
/**
 * Check that the parameter is empty
 * TODO improve it to support Arrays
 * @param value string
 */
export const isEmpty = (value) => {
    return value.trim().length == 0;
};
/**
 * Check that the parameter is defined, not null and not undefined
 * @param o any
 */
export const isDefined = (o) => o !== null && o !== undefined;
/**
 * Check that the parameter is defined, not null and not undefined
 * @param o any
 */
export const isUndefined = (o) => !isDefined(o);
/**
 * returns true if the current user has the given role
 */
export const is = (role, datalab) => {
    if (role == "owner" /* Roles.owner */) {
        if (isUndefined(datalab)) {
            throw new Error("You are checking the owner of an undefined datalab");
        }
        if (isDefined(datalab.owner)) {
            return datalab.owner.username == appState.user.username;
        }
        else {
            return false;
        }
    }
    if (role == "user" /* Roles.none */) {
        return true;
    }
    const access = getServiceContainer().resolve('AccessControl');
    logger.debug(`Checking roles against user role ${role} -> ${access.hasRole(role)}`);
    return access.hasRole(role);
};
export const isArray = (o) => isDefined(o.reduce);
/**
 * Determine if an object can be shown, if should have a roles key
 * @param element an object with a list of role
 */
export const hasRights = (element, datalab) => {
    // check if the current object has a role member, that's the condition
    if (isUndefined(element.roles) || !isArray(element.roles)) {
        // this is either undefined or not an array
        throw "You need to specify an object with a key 'roles' as an Array of accepted role";
    }
    const hasRight = element.roles.some((role) => is(role, datalab));
    logger.debug(`Checking rights for secured component: ${element.roles} => ${hasRight}`);
    // should have at least one role to return true
    return hasRight;
};
/**
 * Check if a datalab belongs to the current logged user
 * @param datalab
 * @returns
 */
export const isOwner = (datalab) => {
    return is("owner" /* Roles.owner */, datalab);
};
export function checkImgURL(url) {
    return url && url.match(/\.(jpeg|jpg|gif|png)$/) != null;
}
